import React, { useEffect, useState } from 'react';
import { DistrictSelectPopUp } from '../../shared/DistrictSelectPopUp';
import { PaymentTypeEnum } from '../../../services/V2/gozer';
import { CreditCardTypeEnum } from '../../../services/V2/longhorn';
import { Button, Divider, Grid } from '@material-ui/core';
import { DistrictsVService } from '../../../services/V2/padre';
import SearchIcon from '@material-ui/icons/Search';
import { AccountSearch } from '../../shared/AccountSearch';
import CurrencyInput from 'react-currency-input-field';
import { PaymentChannels } from '../../../services/PaymentChannels';
import { CreditCardTypes } from '../../../services/CreditCardTypes';
import { PaymentMethodTypes } from '../../../services/PaymentMethodTypes';
import { PaymentStatuses } from '../../../services/PaymentStatuses';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export function ReportCriteria({ model, operatorId, districtId, districtName, setModel, submit, errorToast, setLoading, loading }) {
	const [showDistrictsBox, setShowDistrictsBox] = useState<boolean>(false);
	const [selectedDistricts, setSelectedDistricts] = useState<any>([]);
	const [districts, setDistricts] = useState<any[]>([]);
	const [selectAll, setSelectAll] = useState<boolean>(false);
	const [showSearch, setShowSearch] = useState<boolean>(false);
	const [paymentDate, setPaymentDate] = useState<any[]>([]);
	const [postingDate, setPostingDate] = useState<any[]>([]);
	const [fundingDate, setFundingDate] = useState<any[]>([]);

	useEffect(() => {
		if (!districtId || !operatorId) return;
		setLoading(true)
		DistrictsVService.districtsVGetAll({
			pageNumber: 1,
			orderBy: "Code",
			orderByDesc: false,
			filters: [{ property: "OperatorId", value: operatorId }]
		})
			.then((x: any) => {
				setDistricts(x.items);
				setLoading(false)
			})
			.catch((x) => { setLoading(false) });
	}, [operatorId, districtId]);// eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (!districts) return;
		if (model != null) {
			setPaymentDate([
				model.paymentDateFrom,
				model.paymentDateTo
			])
			setPostingDate([
				model.postingDateFrom,
				model.postingDateTo
			])
			setFundingDate([
				model.fundingDateFrom,
				model.fundingDateTo
			])
			setSelectedDistricts(model.districts.map(x => ({ id: x, name: districts.find(d => d.id === x)?.name })))
		} else {
			if (districtId && districtName) {
				setModel({
					...model,
					districts: [districtId],
					operatorId: operatorId
				});
				setSelectedDistricts([{ id: districtId, name: districtName }]);
			};
		}
	}, [districtId, districtName, districts]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (selectedDistricts.length === 0) return;

		setModel({
			...model,
			districts: selectedDistricts.map((x) => x.id),
		});

		if (model != null) {
			setPaymentDate([
				model.paymentDateFrom,
				model.paymentDateTo,
			]);
			setPostingDate([
				model.postingDateFrom,
				model.postingDateTo,
			]);
			setFundingDate([
				model.fundingDateFrom,
				model.fundingDateTo,
			]);
		}
	}, [selectedDistricts, districts]); // eslint-disable-line react-hooks/exhaustive-deps


	const handleDistrictsLinkClick = () => {
		setShowDistrictsBox(true);
	};

	const handleChange = (event) => {
		let name = event.target.name;
		let value = event.target.value === '' ? null : event.target.value;

		if (event.target.type === 'checkbox') {
			name = event.target.name;
			value = event.target.checked;
		}
		setModel({
			...model,
			[name]: value,
		});
	};

	const formatLocalDate = (date: Date | null, endOfDay: boolean = false): string | null => {
		if (!date) return null;
		const d = new Date(date);
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return endOfDay
			? `${year}-${month}-${day}T23:59:59.999Z`
			: `${year}-${month}-${day}T00:00:00.000Z`;
	};

	const handleDateTimeChange = (event, dateName) => {
		let name = dateName + "From"
		let name2 = dateName + "To"
		if (event === null) event = [null, null]
		event.sort((a, b) => (new Date(a) as any) - (new Date(b) as any))
		setModel({
			...model,
			[name]: formatLocalDate(event[0]),
			[name2]: formatLocalDate(event[1], true),
		});
		if (dateName === "paymentDate")
			setPaymentDate([
				event[0],
				event[1]
			])
		else if (dateName === "postingDate")
			setPostingDate([
				event[0],
				event[1]
			])
		else if (dateName === "fundingDate")
			setFundingDate([
				event[0],
				event[1]
			])
	}

	const handlePaymentMethod = (event) => {
		let value = event.target.value;
		if ((Object.values(CreditCardTypeEnum) as string[]).includes(value)) {
			setModel({
				...model,
				paymentMethodType: value,
				cardType: value,
				paymentMethod: null
			});
		} else if ((Object.values(PaymentTypeEnum) as string[]).includes(value)) {
			setModel({
				...model,
				paymentMethodType: value,
				paymentMethod: value,
				cardType: null
			});
		} else {
			setModel({
				...model,
				paymentMethodType: null,
				paymentMethod: null,
				cardType: null
			});
		}
	};
	const handleChangeStatus = (event) => {
		let value = event.target.value;
		let paymentStatusObject = PaymentStatuses.find(x => x.paymentStatusGroup === value)

		setModel({
			...model,
			paymentStatusGroup: paymentStatusObject?.paymentStatusGroup,
			paymentStatus: paymentStatusObject?.paymentStatus,
			paymentTransactionType: paymentStatusObject?.paymentTransactionType,
			paymentProcessStatus: paymentStatusObject?.paymentProcessStatus
		});
	};

	const handleChangeChannel = (event) => {
		let value = event.target.value;
		let channels = PaymentChannels.find(x => x.value === value)?.channels

		setModel({
			...model,
			source: channels,
			channelSelection: value
		});
	};

	const refreshForm = () => {
		setModel({
			districts: selectedDistricts.map((x) => x.id)
		})
		setPaymentDate([
			null,
			null
		])
		setPostingDate([
			null,
			null
		])
		setFundingDate([
			null,
			null
		])
	}

	return (
		<>
			<div style={{ marginTop: '40px' }}>
				{showDistrictsBox && (
					<DistrictSelectPopUp
						isOpen={true}
						handleClose={() => {
							setShowDistrictsBox(false);
						}}
						operatorId={operatorId}
						storeSelectedDistricts={setSelectedDistricts}
						districtIds={selectedDistricts}
						districts={districts}
						setDistricts={setDistricts}
						selectAll={selectAll}
						setSelectAll={setSelectAll}
						selectDistrict={null}
					/>
				)}
			</div >
			{showSearch &&
				<AccountSearch
					isOpen={showSearch}
					handleClose={() => setShowSearch(false)}
					operatorId={operatorId}
					districts={districts}
					listingModel={model}
					setListingModel={(data) => {
						setModel(data);
						setSelectedDistricts([districts.find(x => x.id === data.districts[0])]);
					}}
					setBillingAccountId={null}
					forceDistrictSelection={false} />
			}
			<Grid container style={{ height: "400px" }}>
				<Grid container>
					<Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
						<Grid container style={{ display: "flex", flexDirection: "column" }}>
							<Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start", fontSize: '18px', marginLeft: "100px", marginBottom: '10px', fontWeight: 'bold' }}>Search</Grid>
						</Grid>
						<div style={{ display: "flex", justifyContent: "center" }}>
							<label className='uvp-label' htmlFor="accountNumber" style={{ marginTop: '20px' }}>
								<b>Account</b><span>&nbsp;:&nbsp;</span>
								<input
									disabled
									className='uvp-input'
									value={model?.accountNumber ?? ""}
									type="text"
									id="accountNumber"
									name="accountNumber"
									style={{ width: "250px" }} />
							</label>
						</div>
						<div style={{ display: "flex" }}>
							<label className='uvp-label' htmlFor="district" style={{ marginTop: '20px' }}>
								<b>District</b><span>&nbsp;:&nbsp;</span>
								<input
									disabled
									className='uvp-input'
									style={{ width: "250px" }}
									type="text"
									id="district"
									name="district"
									value={selectedDistricts.length > 0 && selectedDistricts.length === districts.length ? "Districts - All"
										: selectedDistricts.length > 1 ? "Districts - Multiple"
											: selectedDistricts.length === 0 ? "None"
												: selectedDistricts[0]?.name} />
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="confirmationNumber" style={{ marginTop: '20px' }}>
								<b>Confirmation Number</b><span>&nbsp;:&nbsp;</span>
								<input
									className='uvp-input'
									style={{ width: "250px" }}
									value={model?.confirmationNumber ?? ""}
									onChange={handleChange}
									type="text"
									id="confirmationNumber"
									name="confirmationNumber" />
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="paymentAmount" style={{ marginTop: '20px' }}>
								<b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
								<CurrencyInput
									id="paymentAmount"
									name="paymentAmount"
									className='uvp-input'
									style={{ width: "250px" }}
									prefix="$"
									decimalScale={2}
									value={model?.paymentAmount ?? ""}
									onValueChange={(e, m, floatValue) => setModel({ ...model, paymentAmount: floatValue?.value })} />
							</label>
						</div>
						<div style={{ display: "flex" }}>
							<label className='uvp-label' htmlFor="batchNumber" style={{ marginTop: '20px' }}>
								<b>Batch Number</b><span>&nbsp;:&nbsp;</span>
								<input
									className='uvp-input'
									style={{ width: "250px" }}
									value={model?.batchNumber ?? ""}
									onChange={handleChange}
									type="text"
									id="batchNumber"
									name="batchNumber"
								/>
							</label>
						</div>
					</Grid>
					<Grid item xs={2} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
						<Grid container style={{ display: "flex", flexDirection: "column" }}>
							<Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start", marginBottom: '36px' }} />
						</Grid>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' style={{ marginTop: '21px', height: "30px" }}>
								<button className='uvp-search-button' onClick={() => setShowSearch(true)}><SearchIcon /></button>
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<div style={{ textAlign: "left" }}>
								<label className='uvp-label' style={{ marginTop: '20px', height: "30px" }}>
									<Button
										className='clickable'
										onClick={handleDistrictsLinkClick}
										style={{
											color: '#0073A8',
											textTransform: "none",
											fontSize: "12px"
										}}>
										<u>Select Multiple Districts</u>
									</Button>
								</label>
							</div>
						</div>
					</Grid>
					<Divider className='divider' orientation='vertical' variant="fullWidth" flexItem style={{ backgroundColor: 'black' }} />
					<Grid item xs={5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
						<Grid container>
							<Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start", fontSize: '18px', marginLeft: "100px", marginBottom: '10px', fontWeight: 'bold' }}>Filter By</Grid>
						</Grid>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="paymentDateFrom" style={{ marginTop: '20px' }}>
								<b>Payment Date</b><span>&nbsp;:&nbsp;</span>
								<DateRangePicker onChange={x => handleDateTimeChange(x, "paymentDate")} value={paymentDate} className="uvp-date-input" />
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="postingDateFrom" style={{ marginTop: '20px' }}>
								<b>Posting Date</b><span>&nbsp;:&nbsp;</span>
								<DateRangePicker onChange={x => handleDateTimeChange(x, "postingDate")} value={postingDate} className="uvp-date-input" />
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="fundingDateFrom" style={{ marginTop: '20px' }}>
								<b>Funding Date</b><span>&nbsp;:&nbsp;</span>
								<DateRangePicker onChange={x => handleDateTimeChange(x, "fundingDate")} value={fundingDate} className="uvp-date-input" editable={false} />
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="paymentChannel" style={{ marginTop: '20px' }}>
								<b>Payment Source</b><span>&nbsp;:&nbsp;</span>
								<select
									className='uvp-select'
									value={model?.channelSelection ?? ""}
									onChange={handleChangeChannel}
									style={{ width: "250px", textAlign: 'left' }}
									name="source"
									id="paymentChannel">
									<option value="">Payment Source - All</option>
									{PaymentChannels
										.map((r) => (
											<option key={r.name} value={r.value}>
												{r.name}
											</option>
										))}
								</select>
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="paymentStatus" style={{ marginTop: '20px' }}>
								<b>Payment Status</b><span>&nbsp;:&nbsp;</span>
								<select
									className='uvp-select'
									id="paymentStatus"
									name="paymentStatus"
									value={model?.paymentStatusGroup ?? ""}
									onChange={handleChangeStatus}
									style={{ width: "250px", textAlign: 'left' }}>
									<option value="">Payment Status - All</option>
									{PaymentStatuses
										.map((r) => (
											<option key={r.name} value={r.paymentStatusGroup}>
												{r.name}
											</option>
										))}
								</select>
							</label>
						</div>
						<div style={{ display: 'flex' }}>
							<label className='uvp-label' htmlFor="paymentMethodType" style={{ marginTop: '20px' }}>
								<b>Payment Method Type</b><span>&nbsp;:&nbsp;</span>
								<select
									className='uvp-select'
									value={model?.paymentMethodType ?? ""}
									onChange={handlePaymentMethod}
									style={{ width: "250px", textAlign: 'left' }}
									name="paymentMethodType">
									<optgroup label='General'>
										<option value="">Payment Method Type - All</option>
										{PaymentMethodTypes
											.map((r) => (
												<option key={r.name} value={r.value}>
													{r.name}
												</option>
											))}
									</optgroup>
									<optgroup label='Credit Card Types'>
										{CreditCardTypes
											.map((r) => (
												<option key={r.name} value={r.value}>
													{r.name}
												</option>
											))}
									</optgroup>
								</select>
							</label>
						</div>
					</Grid>
				</Grid>
				<Grid container style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", marginLeft: "45px", marginTop: "20px" }}>
					<Grid item xs={4}>
						<button
							className='uvp-button green-button'
							type="button"
							onClick={() => {
								if (selectedDistricts.length === 0) {
									errorToast("Please select at least one district and try again.");
									return;
								}
								submit();
							}}
							style={{
								margin: "10px",
								padding: "5px 10px",
								width: "120px"
							}}
						>
							Submit
						</button>
						<button
							className='uvp-button gray-button'
							type="button"
							onClick={() => {
								refreshForm();
							}}
							style={{
								margin: "10px",
								padding: "5px 10px",
								width: "120px"
							}}
						>
							Reset
						</button>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}